import { makeAutoObservable, runInAction } from 'mobx';
import { Match } from 'navigo';

import { ChangePasswordInput } from 'dtos/users/ChangePasswordInput';
import { AuthStore } from 'stores/users/AuthStore';
import { createForm } from 'forms/changePasswordForm';
import { LoadStatus } from 'utils/types';
import { serverUri } from 'utils/config';

export class ChangePasswordStore {
  form = createForm();
  status: LoadStatus = 'none';
  message?: string;

  constructor(private readonly authStore: AuthStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  activate(match: Match) {
    this.status = 'none';
    this.message = undefined;
    this.form.reset();
  }

  async changePassword() {
    this.status = 'loading';
    this.message = undefined;
    const { isValid } = await this.form.validate({ showErrors: true });
    if (!isValid) {
      return;
    }
    const { oldPassword, newPassword } = this.form.values();
    const dto: ChangePasswordInput = {
      oldPassword,
      newPassword,
    };
    try {
      const response = await this.authStore.fetchWithAuth(`${serverUri}/user/password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dto),
      });
      if (!response.ok) throw new Error('Error changing password');
      this.form.reset();
      runInAction(() => {
        this.status = 'success';
        this.message = 'Your password was changed.';
      });
    } catch (err) {
      runInAction(() => {
        this.status = 'error';
        this.message = 'Unable to change password. Please try again.';
      });
    }
  }
}
